module.exports = __webpack_public_path__ + "img/living_footer_img.7ac6bf70.png";